// components/common/Loader.tsx
const Loader = () => {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        
        {/* Optional text */}
        {/* <p className="mt-3 text-sm text-gray-600 font-medium">Loading...</p> */}
      </div>
    </div>
  );
};

// New Table Skeleton Component
export const TableSkeleton = ({ rows = 15, columns = 13 }: { rows?: number; columns?: number }) => {
  return (
    <div className="w-full animate-pulse">
  

      {/* Table Rows Skeleton */}
      <div className="bg-white">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="flex border-b border-gray-100 hover:bg-gray-50">
            {Array.from({ length: columns }).map((_, colIndex) => (
              <div
                key={`cell-${rowIndex}-${colIndex}`}
                className="py-2 mx-px"
                style={{
                  width: colIndex === 0 ? '30px' : 
                         colIndex === 1 ? '125px' : 
                         colIndex === 2 ? '125px' : 
                         colIndex === 3 ? '125px' : 
                         colIndex === 4 ? '80px' : 
                         colIndex === 5 ? '125px' : 
                         colIndex === 6 ? '125px' : 
                         colIndex === 7 ? '90px' : 
                         colIndex === 8 ? '120px' : 
                         colIndex === 9 ? '125px' : 
                         colIndex === 10 ? '120px' : 
                         colIndex === 11 ? '80px' : 
                         '120px'
                }}
              >
                {/* Different content based on column type */}
                {colIndex === 0 ? (
                  // Serial number - centered
                  <div className="h-4 bg-gray-200 rounded mx-1"></div>
                ) : colIndex === 4 || colIndex === 11 ? (
                  // ET/TT numbers - right aligned with shorter width
                  <div className="h-4 bg-gray-200 rounded w-8 ml-auto mr-2"></div>
                ) : colIndex === columns - 1 ? (
                  // Actions column - multiple small circles
                  <div className="flex justify-center space-x-1">
                    <div className="w-4 h-4 bg-gray-200 rounded-full"></div>
                    <div className="w-4 h-4 bg-gray-200 rounded-full"></div>
                    <div className="w-4 h-4 bg-gray-200 rounded-full"></div>
                    <div className="w-4 h-4 bg-gray-200 rounded-full"></div>
                  </div>
                ) : (
                  // Regular text content
                  <div className="h-4 bg-gray-200 rounded mx-2"></div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Loader;